import { combineReducers } from '@reduxjs/toolkit'

import { reducer as purchase } from './purchase'

export default combineReducers({ purchase })
